import React from 'react';
import { DatePicker, Form } from 'antd';

import {
  ActivityExtendedField,
  ExtendedFieldValue,
} from '@totem/components/ticketing/ticketing';

const FormItem = Form.Item;

import dayjs from 'dayjs';

import '../../ticketing.css';

const styles = {
  form: {
    width: '100%',
  },
  formItem: {
    paddingBottom: '0',
    marginBottom: '1rem',
  },
};

type Props = {
  extendedField: ActivityExtendedField;
  extendedFieldValue: ExtendedFieldValue;
  onChange: (name: string, value: string, isValid: boolean) => void;
};

const ExtendedFieldDateTime = ({
  extendedField,
  extendedFieldValue,
  onChange,
}: Props) => {
  const checkIsValid = (checkValue) => {
    if (extendedField.isRequired && checkValue.trim() === '') {
      return false;
    }
    return true;
  };

  const handleChange = (date, dateString) => {
    const newDate = dayjs(date);
    onChange(
      extendedField.name,
      newDate.toISOString(),
      checkIsValid(dateString),
    );
  };

  return (
    <FormItem
      label={extendedField.label}
      colon={false}
      style={styles.formItem}
      required={extendedField.isRequired}
      validateStatus={extendedFieldValue.isValid ? 'success' : 'error'}
    >
      <DatePicker
        name={extendedField.name}
        onChange={handleChange}
        showTime
        format={'L LT'}
        style={{ width: '50%' }}
      />
    </FormItem>
  );
};

export default ExtendedFieldDateTime;
